var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6", sm: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "Full Name",
                        "label-for": "fullName",
                        horizontal: false
                      }
                    },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:255",
                            expression: "'required|max:255'"
                          }
                        ],
                        attrs: {
                          "data-vv-name": "user.fullName",
                          "data-vv-as": "Full Name",
                          size: "lg",
                          id: "fullName"
                        },
                        model: {
                          value: _vm.user.fullName,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "fullName", $$v)
                          },
                          expression: "user.fullName"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputValidationErrors.has(
                                "user.fullName"
                              ),
                              expression:
                                "inputValidationErrors.has('user.fullName')"
                            }
                          ],
                          staticClass: "text-info"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inputValidationErrors.first("user.fullName")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "Email Address",
                        "label-for": "emailAddress",
                        horizontal: false
                      }
                    },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email|max:255",
                            expression: "'required|email|max:255'"
                          }
                        ],
                        attrs: {
                          id: "emailAddress",
                          size: "lg",
                          "data-vv-name": "user.emailAddress",
                          "data-vv-as": "Email Address",
                          autocomplete: "email"
                        },
                        model: {
                          value: _vm.user.emailAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "emailAddress", $$v)
                          },
                          expression: "user.emailAddress"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputValidationErrors.has(
                                "user.emailAddress"
                              ),
                              expression:
                                "inputValidationErrors.has('user.emailAddress')"
                            }
                          ],
                          staticClass: "text-info"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inputValidationErrors.first(
                                "user.emailAddress"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "Password",
                        "label-for": "password",
                        horizontal: false
                      }
                    },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value:
                              "" +
                              (_vm.passwordRequired
                                ? "required|min:8|max:255"
                                : "max:255|min:8"),
                            expression:
                              "`${passwordRequired ? 'required|min:8|max:255' : 'max:255|min:8'}`"
                          }
                        ],
                        attrs: {
                          id: "password",
                          type: "password",
                          "data-vv-name": "user.password",
                          "data-vv-as": "Password",
                          autocomplete: "new-password",
                          size: "lg"
                        },
                        model: {
                          value: _vm.user.password,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "password", $$v)
                          },
                          expression: "user.password"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputValidationErrors.has(
                                "user.password"
                              ),
                              expression:
                                "inputValidationErrors.has('user.password')"
                            }
                          ],
                          staticClass: "text-info"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inputValidationErrors.first("user.password")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "CSE-IT Trained?",
                        "label-for": "cse-it-trained",
                        horizontal: false
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "switch switch-lg switch-text switch-pill switch-primary-outline-alt mb-0 wide-toggle"
                        },
                        [
                          _c("input", {
                            staticClass: "switch-input",
                            attrs: { id: "positive_switch", type: "checkbox" },
                            domProps: { checked: _vm.user.isCseitTrained },
                            on: { change: _vm.toggleIsCseitTrained }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "switch-label",
                            attrs: {
                              "data-on": "CSE-IT Trained",
                              "data-off": "Not CSE-IT Trained"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "switch-handle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "Active",
                        "label-for": "active",
                        horizontal: false
                      }
                    },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          "data-vv-name": "user.active",
                          "data-vv-as": "Active",
                          size: "lg",
                          value: _vm.user.isRemoved
                            ? "Deactivate"
                            : _vm.user.active,
                          options: _vm.getUserActiveOptions(
                            _vm.isSuperAdminOptions
                          ),
                          id: "active"
                        },
                        on: { change: _vm.handleSelect }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputValidationErrors.has(
                                "user.active"
                              ),
                              expression:
                                "inputValidationErrors.has('user.active')"
                            }
                          ],
                          staticClass: "text-info"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inputValidationErrors.first("user.active")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "Super Admin",
                        "label-for": "isSuperAdmin",
                        horizontal: false
                      }
                    },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          "data-vv-name": "user.isSuperAdmin",
                          "data-vv-as": "is Super Admin",
                          size: "lg",
                          options: _vm.isSuperAdminOptions,
                          id: "isSuperAdmin"
                        },
                        model: {
                          value: _vm.user.isSuperAdmin,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "isSuperAdmin", $$v)
                          },
                          expression: "user.isSuperAdmin"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputValidationErrors.has(
                                "user.isSuperAdmin"
                              ),
                              expression:
                                "inputValidationErrors.has('user.isSuperAdmin')"
                            }
                          ],
                          staticClass: "text-info"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inputValidationErrors.first(
                                "user.isSuperAdmin"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "State",
                        "label-for": "user-state"
                      }
                    },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          "data-vv-name": "stateName",
                          "data-vv-as": "stateName",
                          size: "lg",
                          options: _vm.stateAndAbbrev,
                          id: "stateName"
                        },
                        model: {
                          value: _vm.stateName,
                          callback: function($$v) {
                            _vm.stateName = $$v
                          },
                          expression: "stateName"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputValidationErrors.has("stateName"),
                              expression:
                                "inputValidationErrors.has('stateName')"
                            }
                          ],
                          staticClass: "text-info"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.inputValidationErrors.first("stateName"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "Primary Organization",
                        "label-for": "primaryOrganization",
                        horizontal: false
                      }
                    },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          size: "lg",
                          "data-vv-name": "user.primaryOrganization",
                          "data-vv-as": "Primary Organization",
                          options: _vm.primaryOrganizationOptions(
                            _vm.organizations
                          ),
                          id: "primaryOrganization"
                        },
                        model: {
                          value: _vm.user.primaryOrganization,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "primaryOrganization", $$v)
                          },
                          expression: "user.primaryOrganization"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputValidationErrors.has(
                                "user.primaryOrganization"
                              ),
                              expression:
                                "inputValidationErrors.has('user.primaryOrganization')"
                            }
                          ],
                          staticClass: "text-info"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inputValidationErrors.first(
                                "user.primaryOrganization"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.addUser
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "m-3",
                              attrs: {
                                id: "isOrgAdminOff",
                                name: "isOrgAdminOff",
                                "unchecked-value": "false",
                                switch: "",
                                incline: ""
                              },
                              model: {
                                value: _vm.membership.isOrgAdmin,
                                callback: function($$v) {
                                  _vm.$set(_vm.membership, "isOrgAdmin", $$v)
                                },
                                expression: "membership.isOrgAdmin"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Organization Administrator: Would you like for this user to be able to share, unshare and transfer records?\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "m-3",
                              attrs: {
                                id: "isOrgManagerOff",
                                name: "isOrgManagerOff",
                                "unchecked-value": "false",
                                switch: "",
                                incline: ""
                              },
                              model: {
                                value: _vm.membership.isManager,
                                callback: function($$v) {
                                  _vm.$set(_vm.membership, "isManager", $$v)
                                },
                                expression: "membership.isManager"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Organization Manager: Would you like this user to be able to view all of the records for your organization?\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("addOrUpdate", _vm.user)
                        }
                      }
                    },
                    [_vm._v("Submit")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9dca2dd2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dca2dd2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/UserForm.vue
// module id = 1845
// module chunks = 0